var anchrorClassShow = document.getElementsByClassName('show-more');

for (var i = 0; i < anchrorClassShow.length; i++) {
    anchrorClassShow[i].addEventListener('click', function (e) {
        e.preventDefault();
        var parentDiv = this.parentElement;
        if (parentDiv.children[0].className.match(/hideContent/g)) {
            this.innerHTML = 'Ver menos';
            parentDiv.children[0].className =
                'product__description rte quick-add-hidden container partial content showContent';
        } else {
            this.innerHTML = 'Ver mais';
            parentDiv.children[0].className =
                'product__description rte quick-add-hidden container partial content hideContent';
        }
    });
}
